import React, {useEffect, useState} from 'react'
import { twMerge } from 'tailwind-merge'

export default function Pagination({total, page, setPage, className = ""}) {

  const [pages, setPages] = useState([])

  useEffect(() => {
    const pages = []
    for (let i = 1; i <= Math.ceil(total / 50); i++) {
      if (i == 1 || i == Math.ceil(total / 50) || Math.abs(i - page) < 3) {
        pages.push(i)
      }
    }
    setPages(pages)
  }, [total, page])

  return <ul className={twMerge("flex mb-4", className)}>
    {pages.map((p, index) =>
      <React.Fragment key={p}>
        {index > 0 && pages[index - 1] != p - 1 && <li className="group"><span className="block p-3 leading-4 border group-first:rounded-l group-last:rounded-r border border-l-0 group-first:border-l">...</span></li>}
        <li className="group">
          <a onClick={() => setPage(p)} className={twMerge('block p-3 leading-4 border group-first:rounded-l group-last:rounded-r border border-l-0 group-first:border-l', p == page ? 'bg-blue-600 text-white' : 'cursor-pointer')}>{p}</a>
        </li>
      </React.Fragment>
    )}
  </ul>
}
